import { save, openWhatsapp, getMeta, isDesktop, getMessage, isSendMessageToWhatsappEnabled } from './../store.js';

(function ($) {
    $(document).ready(function () {
        /** Catch CF7 Form */
        const handleFormSubmission = async (e) => {

            // Bail if not successful
            if (e.detail.apiResponse.status !== 'mail_sent') return;

            const settings = e.detail.apiResponse.formychat || {}

            // Collect lead data
            // Multi-value fields (checkbox, multi-select) arrive as one "name[]" entry per value;
            // group them under the base name so template tags like [checkbox-682] resolve.
            const inputs = e.detail.inputs.reduce((fields, input) => {
                if (!input.name.endsWith('[]')) {
                    fields[input.name] = input.value;
                    return fields;
                }

                const name = input.name.slice(0, -2);
                fields[name] = [ ...(fields[name] || []), input.value ];
                return fields;
            }, {});
            
            // Closest .formychat-widget-custom-form of the e.target
            const form = e.target;
            const widget = form.closest('[data-widget]');
            
            const data = {
                form: 'cf7',
                form_id: e.detail.contactFormId,
                field: inputs,
                meta: getMeta.value,
                widget_id: widget ? widget.dataset.widget : null,
            }

            if ( widget ) {
                // Inside widget.
                const widgetId = widget.dataset.widget || null;
                if (!widgetId) return;
    
                const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
                if ( !widgetObject ) return;

                
                try {
                    const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                        ? new URL(formychat_vars.site.url).origin
                        : '*';
                    window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, targetOrigin);
                } catch (err) {
                }

                const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
                const { new_tab, web_version, cf7_message_template, destination_type, group_invite_code } = whatsappConfig;
                const whatsappNumber = formychat_vars.is_premium && destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
                const message = getMessage(cf7_message_template, inputs);
                
                save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
                if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                    openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
                }
                
            } else {
                // Outside widget.
                if ( 'on' !== settings.status ) return;
                let message = getMessage(settings.message, inputs, /\[(.*?)\]/);

                const to = formychat_vars.is_premium && settings.destination_type === 'group' && settings.group_invite_code ? settings.group_invite_code : settings.whatsapp_number;
                save(data, to, message, isDesktop(), 'on' == settings.new_tab);
                openWhatsapp(to, message, isDesktop(), 'on' == settings.new_tab, settings);
            }
        }

        document.addEventListener('wpcf7submit', handleFormSubmission);

    });

})(jQuery)